<app-stepper-form
  header="Add Historical Transaction"
  submitButtonText="Add Transaction"
  [steps]="steps"
  [currentStep]="currentStep"
  [currentStepIndex]="currentStepIndex"
  [isLoading]="isLoading"
  [form]="stepperForm"
  [showSaveAndCompleteLaterBtn]="false"
>
  <div class="step-content full-width" [formGroup]="stepperForm">
    <section
      class="step-section"
      [formGroupName]="StepsEnum.TransactionType"
      [hidden]="currentStep !== StepsEnum.TransactionType"
    >
      <h1 class="h1-heading">{{ steps[currentStepIndex].label }}</h1>
      <app-radio
        formControlName="transactionType"
        [options]="transactionTypeOptions"
        [horizontalAlign]="false"
      />
    </section>

    <!--  ===== ===== BALANCE ===== =====  -->

    <section
      class="step-section"
      [formGroupName]="StepsEnum.Balance"
      [hidden]="currentStep !== StepsEnum.Balance"
      [formGroup]="stepperForm.controls[StepsEnum.Balance]"
    >
      <h1 class="h1-heading">{{ steps[currentStepIndex].label }}</h1>

      <div class="form-group">
        <app-date-picker
          label="Balance Date"
          formControlName="balanceDate"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [smallWidth]="true"
          [customErrors]="customDatepickerErrors"
        />
      </div>

      <app-share-balance-block
        [securityRegistryRecords]="securityRegistryRecords"
        [securityTypes]="securityTypes"
        [companyChangeData]="companyChangeData"
      />
    </section>


    <!--  ===== ===== ISSUE ===== =====  -->

    <section
      class="step-section"
      [formGroupName]="StepsEnum.Issue"
      [hidden]="currentStep !== StepsEnum.Issue"
      [formGroup]="stepperForm.controls[StepsEnum.Issue]"
    >
      <h1 class="h1-heading">{{ steps[currentStepIndex].label }}</h1>

      <div class="form-group">
        <app-date-picker
          label="Date of Issue"
          formControlName="issueDate"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [smallWidth]="true"
          [customErrors]="customDatepickerErrors"
        />
      </div>

      <app-share-issue-block
        [securityRegistryRecords]="securityRegistryRecords"
        [securityTypes]="securityTypes"
        [companyChangeData]="companyChangeData"
      />

      <div class="form-group">
        <input-certificate-number
          label="Certificate Number"
          formControlName="shareCertificateNumber"
          [entityId]="companyChangeData.entityId"
          [transactionsList]="transactionsList"
          [isRequired]="false"
        />
      </div>
    </section>

    <!--  ===== ===== CANCELLATION ===== =====  -->

    <section
      class="step-section"
      [formGroupName]="StepsEnum.Cancellation"
      [hidden]="currentStep !== StepsEnum.Cancellation"
      [formGroup]="stepperForm.controls[StepsEnum.Cancellation]"
    >
      <h1 class="h1-heading">{{ steps[currentStepIndex].label }}</h1>

      <div class="form-group">
        <app-date-picker
          label="Date of Cancellation"
          formControlName="cancellationDate"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [smallWidth]="true"
          [customErrors]="customDatepickerErrors"
        />
      </div>

      <app-share-cancellation-block
        [securityRegistryRecords]="securityRegistryRecords"
        [companyChangeData]="companyChangeData"
        [parentFormGroup]="stepperForm"
      />

      <div class="form-group">
        <input-certificate-number
          label="Certificate Number"
          formControlName="shareCertificateNumber"
          [entityId]="companyChangeData.entityId"
          [transactionsList]="transactionsList"
          [isRequired]="false"
        />
      </div>
    </section>

    <!--  ===== ===== TRANSFER FROM ===== =====  -->

    <section
      class="step-section transfer-from"
      [formGroupName]="StepsEnum.TransferFrom"
      [hidden]="currentStep !== StepsEnum.TransferFrom"
    >
      <h1 class="h1-heading">Transferor (Seller)</h1>

      <div class="form-group">
        <app-date-picker
          label="Date of Transfer"
          formControlName="transferDate"
          [smallWidth]="true"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [customErrors]="customDatepickerErrors"
        />
      </div>

      <app-share-transfer-from-block
        [formGroup]="stepperForm.controls[StepsEnum.TransferFrom]"
        [securityRegistryRecords]="securityRegistryRecords"
        [transferToBlock]="shareTransferToBlock!"
      />
    </section>

    <!--  ===== ===== TRANSFER TO ===== =====  -->

    <section
      class="step-section transfer-to"
      [formGroupName]="StepsEnum.TransferTo"
      [hidden]="currentStep !== StepsEnum.TransferTo"
    >
      <h1 class="h1-heading">Transferee (Buyer)</h1>

      <app-share-transfer-to-block [formGroup]="stepperForm.controls[StepsEnum.TransferTo]"/>

      <div class="form-group">
        <input-certificate-number
          label="Certificate Number"
          formControlName="shareCertificateNumber"
          [entityId]="companyChangeData.entityId"
          [transactionsList]="transactionsList"
        />
      </div>
    </section>

    <!--  ===== ===== SUBDIVISION ===== =====  -->

    <section
      class="step-section subdivision"
      [formGroupName]="StepsEnum.Subdivision"
      [hidden]="currentStep !== StepsEnum.Subdivision"
    >
      <h1 class="h1-heading mb-4">Subdivision / Consolidation</h1>

      <app-share-subdivision-conversion-block
        [securityRegistryRecords]="securityRegistryRecords"
        [maxDate]="maxDate"
        [minDate]="minDate"
      />
    </section>

  </div>
</app-stepper-form>
